import React from "react";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import "@fortawesome/fontawesome-svg-core/styles.css";

library.add(fab);

export default function Footer() {
  return (
    <footer
      className="footer mt-5 pt-5 px-0 px-md-5 px-lg-5 px-xl-5 text-white"
      style={{ background: "#212529" }}
    >
      <div className="container">
        <div className="row">
          {/* About Section */}
          <div className="col-md-4">
            <h5 className="text-uppercase">About CAE 21</h5>
            <p>
              CAE 21st Century Private Limited is a dynamic EdTech startup
              committed to transforming education for the digital era.
            </p>
          </div>

          {/* Quick Links Section */}
          <div className="col-md-4">
            <h5 className="text-uppercase">Quick Links</h5>
            <ul className="list-unstyled">
              <li>
                <Link to="/" className="text-white">
                  Home
                </Link>
              </li>
              <li>
                <Link to="#about-us" className="text-white">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="#our-offerings" className="text-white">
                  Offerings
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="text-white">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info Section */}
          <div className="col-md-4">
            <h5 className="text-uppercase">Contact Us</h5>
            <p>
              <strong>Email:</strong>cae21.info@gmail.com
            </p>
            <p>
              <strong>Phone:</strong> +91 9876543210
            </p>
            <p>
              <strong>Address:</strong> B 100, Block B, Sarvodaya Enclave, New
              Delhi, Delhi 110017
            </p>
          </div>
        </div>

        {/* Social Media Icons */}
        <div className="row mt-4">
          <div className="col text-center">
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white me-3"
            >
              <FontAwesomeIcon icon={["fab", "facebook-f"]} />
            </a>
            <a
              href="https://www.twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white me-3"
            >
              <FontAwesomeIcon icon={["fab", "twitter"]} />
            </a>
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white me-3"
            >
              <FontAwesomeIcon icon={["fab", "linkedin-in"]} />
            </a>
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
            >
              <FontAwesomeIcon icon={["fab", "instagram"]} />
            </a>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="row mt-4">
          <div className="col text-center">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} CAE 21st Century. All Rights
              Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
